import bg01 from './bg-01.jpg'
import bg02 from './bg-02.jpg'
import bg03 from './bg-03.jpg'
import bg04 from './bg-04.jpg'
import bg05 from './bg-05.jpg'
import bg06 from './bg-06.jpg'
const imgArray = [bg01, bg02, bg03, bg04, bg05, bg06]

export { imgArray }
